var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{english:_vm.lang=='EN'},staticStyle:{"width":"100%"}},[_c('div',{staticClass:"hidden-xs"},[_c('div',{staticClass:"link-us"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"left wow fadeInUp"},[_c('p',[_vm._v(_vm._s(_vm.$t('news.companynews')))])])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/news/NewsTab.vue?vue&type=template&id=7bdc940e&scoped=true&
// module id = null
// module chunks = 